import * as React from 'react';
import { IFeedbackRequest, IFeedbackResponse } from '../../../types/feedback';
import { ModalAlert } from './alert';
import { ModalForm } from './form';

interface IModalProps {
  onModalClose(): void;
  sendFeedbackAction(params: IFeedbackRequest): Promise<IFeedbackResponse>;
  isMobile?: boolean;
}

interface IModalState {
  isSuccessAlertShown: boolean;
}

export class FeedbackModal extends React.Component<IModalProps, IModalState> {
  public constructor(props: IModalProps) {
    super(props);

    this.state = {
      isSuccessAlertShown: false,
    };
  }

  public render() {
    const { sendFeedbackAction, onModalClose, isMobile } = this.props;
    const { isSuccessAlertShown } = this.state;

    return (
      <div>
        {isSuccessAlertShown ? (
          <ModalAlert onModalClose={onModalClose} isMobile={isMobile} />
        ) : (
          <ModalForm
            sendFeedbackAction={sendFeedbackAction}
            showSuccessAlert={this.showSuccessAlert}
            onModalClose={onModalClose}
            isMobile={isMobile}
          />
        )}
      </div>
    );
  }

  private showSuccessAlert = () => {
    this.setState({
      isSuccessAlertShown: true,
    });
  };
}
